import * as React from "react";
import {Control, Field, TextArea} from "bloomer";

interface ITranslationModelOutputState {
    result: any;
    errorMessage: string;
}

class TranslationModelOutput extends React.Component<{}, ITranslationModelOutputState> {
    public constructor(props: {}) {
        super(props);

        this.state = {
            result: null,
            errorMessage: ""
        };
    }

    public processResponse = (response: any) => {
        let result = "";

        if (response && response.result) {
            result = response.result;
        }

        if (result) {
            this.setState({
                result
            });
        } else {
            this.setState({
                errorMessage: "Unable to translate."
            });
        }
    };

    public render() {
        return (
            <React.Fragment>
                {
                    this.state.result ? <Field>
                        <Control>
                            <TextArea
                                readOnly={true}
                                value={this.state.result}
                                placeholder="Output"
                            />
                        </Control>
                    </Field> : <></>
                }
            </React.Fragment>
        );
    }
}

export default TranslationModelOutput;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/CrossProvider/output/Translation/TranslationModelOutput.tsx